import store from '../store'
import { auth } from '../api/firebase'

export default async (to, from, next) => {
    if (store.state.auth.currentUser) {
        next({ name: 'dashboard' })
    } else {
        if (auth.currentUser) {
            await store.dispatch('auth/SET_AUTH', {
                refresh: true
            })
            next({ name: 'dashboard' })
        } else {
            next()
        }
    }
}
